import * as React from "react";
import { Tag, Row, Col } from "antd";

import "styles/tagEnhance.less";

interface ITagEnhance {
  tags: any;
  // 一行显示的tag数量
  size: number;
}

class TagEnhance extends React.Component<ITagEnhance, any> {
  constructor(props: ITagEnhance) {
    super(props);
  }

  // 显示tag
  showTag = () => {
    let tags: any = [],
      tagInfo: any = this.props.tags,
      cols: any = [],
      span: number = 0,
      rowEndSpan: number = 0,
      currentSpan: number = 0,
      isNewRow: boolean = false;

    span = parseInt((24 / this.props.size).toString());

    if (24 % this.props.size === 0) {
      rowEndSpan = span;
    } else {
      span = span + 1;
      rowEndSpan = 24 - (this.props.size - 1) * span;
    }

    tagInfo.forEach((item, index: number) => {
      if (index === 0) {
        currentSpan = span;
      } else if ((index + 1) % this.props.size !== 0) {
        currentSpan = span;
      } else {
        currentSpan = rowEndSpan;
        isNewRow = true;
      }
      cols.push(
        <Col span={currentSpan} key={item.id}>
          <Tag key={item.id} className={item.class}>
            {item.name}
          </Tag>
        </Col>
      );
      if (isNewRow) {
        tags.push(<Row key={tags.length}>{cols}</Row>);
        cols = [];
        isNewRow = false;
      }
    });

    if (cols.length > 0) tags.push(<Row key={tags.length}>{cols}</Row>);
    // for (const item of this.props.tags) {
    //   tags.push(<Tag key={item.id}>{item.name}</Tag>);
    // }
    return tags;
  };

  showTagForUL = () => {
    let tags: any = [],
      tagInfo: any = this.props.tags;
    // cols: any = [];
    // span: number = 0,
    // rowEndSpan: number = 0,
    // currentSpan: number = 0,
    // isNewRow: boolean = false;

    // span = parseInt((24 / this.props.size).toString());

    // if (24 % this.props.size === 0) {
    //   rowEndSpan = span;
    // } else {
    //   span = span + 1;
    //   rowEndSpan = 24 - (this.props.size - 1) * span;
    // }

    tagInfo.forEach((item, index: number) => {
      tags.push(
        <li key={"li_" + item.id}>
          <span key={item.id} className={item.class}>
            {item.name}
          </span>
        </li>
      );

      {
        /* <Tag key={item.id} className={item.class}>
            {item.name}
          </Tag> */
      }
      // if (index === 0) {
      //   currentSpan = span;
      // } else if ((index + 1) % this.props.size !== 0) {
      //   currentSpan = span;
      // } else {
      //   currentSpan = rowEndSpan;
      //   isNewRow = true;
      // }
      // cols.push(
      //   <Col span={currentSpan} key={item.id}>
      //     <Tag key={item.id} className={item.class}>
      //       {item.name}
      //     </Tag>
      //   </Col>
      // );
      // if (isNewRow) {
      //   tags.push(<Row key={tags.length}>{cols}</Row>);
      //   cols = [];
      //   isNewRow = false;
      // }
    });

    //if (cols.length > 0) tags.push(<Row key={tags.length}>{cols}</Row>);
    // for (const item of this.props.tags) {
    //   tags.push(<Tag key={item.id}>{item.name}</Tag>);
    // }
    return tags;
  };

  render() {
    return (
      <div className="tag-enhance">
        <ul>{this.showTagForUL()}</ul>
      </div>
    );
  }
}

export default TagEnhance;
